<template>
  <div class="box pb-12" :class="{'is_new_box':box.isTop || box.isNew}">
    <div @click="focusBox" class="image">
      <div v-if="box.isNew" class="new__balloon flex float-right justify-center text-center"><p
        class="transform -rotate-45">New</p></div>
      <div v-if="box.isTop" class="new__balloon flex float-right justify-center text-center"><p
        class="transform -rotate-45">Top</p></div>
      <img v-if="box.thumbnail" :src="box.thumbnail" alt="thumbnail"
           class="border-2 border-classen__secondary">
      <img v-else src="../../../../assets/media/NoImage.png" alt="no image">
    </div>

    <div @click="focusBox" class="mb-1 grid grid-cols-10">
      <p class="font-bold name col-span-8 text-left">{{ box.name }} </p>
    </div>

  </div>
</template>

<script>
import EventBus from "../../../../services/EventBus";
import getTranslation from "../../../../mixins/getTranslation";

export default {
  name: "BoxView",

  mixins: [getTranslation],

  components: {},

  props: {
    box: {required: true, type: Object}
  },

  data() {
    return {}
  },

  created() {

  },

  destroyed() {

  },

  computed: {},

  watch: {},

  methods: {
    focusBox(e) {
      EventBus.fire('set-active_packaging', this.box)
    }
  }
}
</script>

<style scoped>
.box {
  width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.is_new_box {
  margin-top: -40px;
}

img {
  width: 300px;
  height: 195px;
  object-fit: none;
  border-radius: 35px 0 35px 0;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* number of lines to show */
}

.selection {
  position: relative;
  top: -55px;
}

.raise {
  margin-top: -40px;
}
</style>
